import React, { useState, useEffect, useRef } from "react";
import "./BaseLayerSelector.css"; // Asegúrate de incluir los estilos
import {
  get_basemaps_availables,
  get_default_base_map_id,
  replace_base_map,
} from "../../../../../services/MapCore/BaseMapsService";
import { useTranslation } from "react-i18next";

import { IconButton, Tooltip } from "@mui/material";
import { AnimatePresence, motion } from "framer-motion";

import LayersIcon from "@mui/icons-material/Layers";

const BaseLayerSelector = ({ map }) => {
  const { t } = useTranslation("main");
  const [isOpen, setIsOpen] = useState(false);
  const [isHover, setIsHover] = useState(false);
  const selectorRef = useRef(null);
  const baseMapsAviables = get_basemaps_availables();
  const [selectedMapId, setSelectedMapId] = useState(get_default_base_map_id());
  const isSmallHeight = window.innerHeight < 900;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (selectorRef.current && !selectorRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handleBaseMapClick = (baseMap) => {
    setIsOpen(false);
    setIsHover(false);

    replace_base_map(map, baseMap.id);
    setSelectedMapId(baseMap.id);
  };

  // Maneja el hover o click para abrir/cerrar el desplegable
  const toggleDropdown = () => {
    setIsOpen(!isOpen);
    setIsHover(!isOpen);
  };

  return (
    <div
      ref={selectorRef}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
      style={{
        position: "relative",
      }}
    >
      <Tooltip title={t("base_layer_selector")}>
        <IconButton onClick={toggleDropdown} className="mapButton">
          <LayersIcon />
        </IconButton>
      </Tooltip>

      <AnimatePresence>
        {(isOpen || isHover) && (
          <motion.div
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: 10 }}
            transition={{ duration: 0.3 }}
            style={{
              position: "absolute",
              bottom: "58px",
              right: "0",
              display: "flex",
              flexDirection: isSmallHeight
                ? window.innerHeight < window.innerWidth
                  ? "row"
                  : "column"
                : "column",
              alignItems: "center",
              gap: "8px",
            }}
          >
            {Object.entries(baseMapsAviables).map(([key, baseMap]) => {
              return (
                <Tooltip
                  key={key}
                  title={t(baseMap.description)}
                  placement="right"
                  arrow
                >
                  <IconButton
                    className="mapButton baseMapButton"
                    sx={{
                      height: isSmallHeight
                        ? "80px!important"
                        : "100px!important",
                      width: isSmallHeight
                        ? "80px!important"
                        : "100px!important",
                    }}
                    style={{
                      ...(baseMap.id === selectedMapId && {
                        backgroundColor:
                          "var(--color-primary-light-50)!important",
                        borderColor: "var(--color-primary-light-50)!important",
                      }),
                    }}
                    onClick={(e) => {
                      handleBaseMapClick(baseMap);
                      e.preventDefault();
                    }}
                  >
                    <img
                      src={`images/base_map/${baseMap.thumbnail}`}
                      alt={t(baseMap.title)}
                      style={{
                        width: "100%",
                        height: "100%",
                        objectFit: "cover",
                        borderRadius: "2px",
                      }}
                    />
                    <div
                      style={{
                        position: "absolute",
                        backgroundColor: "rgba(0,0,0,0.5)",
                        color: "white",
                        bottom: "8px",
                        width: "calc(100% - 16px)",
                        fontSize: "10px",
                        borderRadius: "0 0 2px 2px",
                      }}
                    >
                      {t(baseMap.title)}
                    </div>
                  </IconButton>
                </Tooltip>
              );
            })}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default BaseLayerSelector;
